import { render, staticRenderFns } from "./MagazineCardWrapper.vue?vue&type=template&id=14308edb&scoped=true&"
import script from "./MagazineCardWrapper.vue?vue&type=script&lang=js&"
export * from "./MagazineCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MagazineCardWrapper.vue?vue&type=style&index=0&id=14308edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14308edb",
  null
  
)

export default component.exports